import * as React from "react"
const SvgTrophy = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 19.714v-3.1a5.4 5.4 0 0 1-2.188-1.037A4.5 4.5 0 0 1 7.4 13.664a4.85 4.85 0 0 1-3.138-1.637A4.8 4.8 0 0 1 3 8.714v-1q0-.825.587-1.412A1.93 1.93 0 0 1 5 5.714h2q0-.825.588-1.412A1.93 1.93 0 0 1 9 3.714h6q.824 0 1.413.588.587.587.587 1.412h2q.824 0 1.413.588.587.587.587 1.412v1q0 1.9-1.262 3.313a4.85 4.85 0 0 1-3.138 1.637q-.45 1.15-1.413 1.913A5.4 5.4 0 0 1 13 16.614v3.1h3q.424 0 .712.288a.97.97 0 0 1 .288.712.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287H8a.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288zm-4-8.2v-3.8H5v1q0 .95.55 1.713.55.762 1.45 1.087m5 3.2a2.9 2.9 0 0 0 2.125-.875A2.9 2.9 0 0 0 15 11.714v-6H9v6q0 1.25.875 2.125a2.9 2.9 0 0 0 2.125.875m5-3.2a3 3 0 0 0 1.45-1.087q.55-.764.55-1.713v-1h-2z" />
  </svg>
)
export default SvgTrophy
